<template>
  <div class="toolbar-wrapper">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'ToolbarWrapper'
}
</script>

<style lang="less" scoped>
.toolbar-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5em 0;

  & > .btn,
  & > .btn-group,
  & > span {
    margin-right: 0.5em;
  }
}
</style>
